import React, { useCallback, useEffect, useState } from 'react';
import { View, TextInput, Text, StyleSheet, ActivityIndicator, TouchableOpacity } from 'react-native';
import { usePersistBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store';
import { LoginResponse, User } from '../services/AuthDataTypes';
import { authUser, getUser } from '@/services/typo3api/auth';
import { useRouter } from 'expo-router';
import { emitEvent } from '@/services/EventService';
import OnboardingOverlay from './Onboarding';
import { fetchSubscriptions } from '@/services/fetchSubscriptions';

export default function LoginComponent() {
  const router = useRouter();
  const [username, setUsername] = useState('Test');
  const [password, setPassword] = useState('test');
  const [loading, setLoading] = useState(false);
  const login = usePersistSecureBoundStore(useCallback((state) => state.login, []));
  const user = usePersistSecureBoundStore.getState().user;
  const updateSubscriptions = usePersistSecureBoundStore.getState().updateSubscriptions;
  const updateSessionFavouriteEdition = usePersistBoundStore.getState().updateFavouriteEdition;
  const updateSessionFavouriteDate = usePersistBoundStore.getState().updateSessionFavouriteDate;

  const handleLogin = async () => {
    setLoading(true);
    const TIMEOUT_DURATION = 5000;
    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Login timed out")), TIMEOUT_DURATION)
    );

    try {
      const response = await Promise.race([
        await authUser(username, password),
        timeout
      ]) as LoginResponse;

      await getUser(response.token);

      const loginData: User = {
        id: response.uid,
        name: response.username,
        permissions: ['user'],
        subscriptions: null,
        favouriteEdition: 'DLZ',
      };

      login(loginData);
      const newSubscriptions = await fetchSubscriptions(loginData.id);
      updateSubscriptions(newSubscriptions);
      updateSessionFavouriteEdition(loginData.favouriteEdition as string);
      updateSessionFavouriteDate(null);

    } catch (error) {
      console.error((error as Error).message);
    } finally {
      emitEvent('LoginEvent', null);
      setLoading(false);
    }
  };

  const handleSignup = async () => {
    router.push({
      pathname: '/',
      params: { webViewURL: 'registrierung.html' },
    });
  }
  const handleForgotPassword = async () => {
    router.push({
      pathname: '/',
      params: { webViewURL: 'login.html?tx_felogin_login%5Baction%5D=recovery&tx_felogin_login%5Bcontroller%5D=PasswordRecovery&cHash=ad46ba52c261c4eb6333e963b7633c1a' },
    });
  }

  return (
    <View style={styles.container}>
      <OnboardingOverlay page="login" />
      <Text style={styles.label}>Login: Test - Test</Text>
      <Text></Text><Text></Text><Text></Text><Text></Text>
      <Text style={styles.label}>Username</Text>
      <TextInput
        style={styles.input}
        value={username}
        onChangeText={setUsername}
        placeholder="Enter username"
      />
      <Text style={styles.label}>Password</Text>
      <TextInput
        style={styles.input}
        value={password}
        onChangeText={setPassword}
        placeholder="Enter password"
        secureTextEntry
      />
      {loading ? (
        <ActivityIndicator size="large" color="#00ff00" />
      ) : (
        <>
          <TouchableOpacity onPress={handleLogin}
            style={{
              width: '80%',
              padding: 20,
              backgroundColor: '#069',
              borderRadius: 8,
              alignSelf: 'center',
              alignItems: 'center',
              margin: 10,
            }}>
            <Text style={{ color: '#fff' }}>Login</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={handleSignup}
            style={{
              width: '80%',
              padding: 5,
              backgroundColor: '#069',
              borderRadius: 8,
              alignSelf: 'center',
              alignItems: 'center',
              margin: 5,
            }}>
            <Text style={{ color: '#fff' }}>Registrieren</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={handleForgotPassword}
            style={{
              width: '80%',
              padding: 5,
              backgroundColor: '#069',
              borderRadius: 8,
              alignSelf: 'center',
              alignItems: 'center',
              margin: 5,
            }}>
            <Text style={{ color: '#fff' }}>Passwort vergessen</Text>
          </TouchableOpacity>
        </>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  label: {
    fontSize: 16,
    marginBottom: 5,
    color: '#fff',
  },
  label_small: {
    fontSize: 6,
    marginBottom: 3,
    color: '#fff',
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    padding: 10,
    marginBottom: 15,
    borderRadius: 5,
    color: '#fff',
  },
});